<template>
  <div class="content">
    <b-img-lazy
      class="image"
      :src="cx_image"
      alt="sem resultado na região marketplace Clinicarx"
      title="sem resultado na região marketplace Clinicarx"
    ></b-img-lazy>
    <p class="text-center font-weight-bold home-service-title main-text">
      Infelizmente não encontramos nenhum ponto de saúde parceiro da Clinicarx nessa região.
    </p>
    <p class="open-sans-font text-secondary">
      Você pode utilizar a barra de pesquisa no topo dessa página ou voltar para a tela inicial e
      tentar com outro CEP.
    </p>
    <b-button @click="goToHome()" class="btn-home">Voltar a página inicial</b-button>
  </div>
</template>
<script>
import NoResultArea from "@/components/ClinicsResult/NoResultArea/NoResultArea";
export default NoResultArea;
</script>

<style lang="scss">
@import "NoResultArea.scss";
</style>
